import React, { createContext, useContext } from 'react';
import { ViewIcon, SettingsIcon, EmailIcon, StarIcon, ChatIcon, CheckIcon } from '@chakra-ui/icons';
import { useAuth } from './AuthContext';

const NavigationContext = createContext();

export function useNavigation() {
  return useContext(NavigationContext);
}

export function NavigationProvider({ children }) {
  const { isAdmin } = useAuth();

  const adminNav = [
    {
      label: 'Dashboard',
      path: '/',
      icon: <ViewIcon />,
    },
    {
      label: 'Email Verification',
      path: '/verify',
      icon: <CheckIcon />,
    },
    {
      label: 'Email Monitor',
      path: '/emails',
      icon: <EmailIcon />,
    },
    {
      label: 'Agent Config',
      path: '/agents',
      icon: <SettingsIcon />,
    },
    {
      label: 'Rules',
      path: '/rules',
      icon: <StarIcon />,
    },
    {
      label: 'Feedback',
      path: '/feedback',
      icon: <ChatIcon />,
    },
  ];

  const value = {
    adminNav,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}
